var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-open-form"},[_c('div',{staticClass:"mw-from-top-con",attrs:{"id":"mw-form"}}),_vm._v(" "),_c('div',{staticClass:"mw-form-bot-btns"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.saveFormData()}}},[_vm._v("保存")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ec312e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/extend/general-form/src/main.vue
// module id = 877
// module chunks = 0 1